import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import * as FLAGS from '../../icons/flags';
import { CountryCode } from './types';

export interface FlagIconProps {
  country?: CountryCode;
  style?: CSSProperties;
  className?: string;
  size?: number;
}

export const CountryCodes = Object.keys(FLAGS) as CountryCode[];

export const FlagIcon: React.FC<React.PropsWithChildren<FlagIconProps>> = ({
  country,
  size = 32,
  style,
  className
}) => {
  if (!country || !FLAGS[country]) {
    return null;
  }
  const flag = FLAGS[country];
  return (
    <StyledIconContainer $size={size} style={style} className={className}>
      <img src={flag} title={country} style={{ width: '100%', verticalAlign: 'middle' }} alt="flag" />
    </StyledIconContainer>
  );
};

const StyledIconContainer = styled.span<{ $size: number }>`
  width: ${({ $size }) => $size}px;
  vertical-align: middle;
  text-align: center;
  display: inline-block;
`;
